var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingStarBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.78572 0.912942C9.08585 -0.00672257 10.3869 -0.00672483 10.687 0.91294L12.1046 5.25656C12.2388 5.66795 12.6225 5.9463 13.0552 5.9463H17.6332C18.603 5.9463 19.005 7.18817 18.2193 7.75655L14.5232 10.4301C14.1712 10.6847 14.0239 11.1375 14.1587 11.5506L15.5722 15.8818C15.8726 16.8024 14.82 17.5699 14.0355 17.0023L10.3225 14.3166C9.97269 14.0635 9.50005 14.0635 9.15028 14.3166L5.43727 17.0023C4.6527 17.5699 3.60011 16.8024 3.90053 15.8818L5.31407 11.5506C5.44887 11.1375 5.30154 10.6847 4.94951 10.4301L1.25349 7.75655C0.467716 7.18817 0.869784 5.9463 1.83958 5.9463H6.4175C6.85025 5.9463 7.23389 5.66795 7.36815 5.25656L8.78572 0.912942Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarBlank);
export default __webpack_public_path__ + "static/media/rating_star_blank.2bb0965aa6695623cbe0340da3daef8d.svg";
export { ForwardRef as ReactComponent };